import { createTheme } from '@mui/material/styles'

import { LinkBehavior } from '../components/ui/LinkBehavior'

import { getThemeConfig } from './theme'

const themeConfig = getThemeConfig()

// Overrides cube-core themes to add functionality
export const getCreateThemeWithRouterComponents = () => {

  // Override link components to work with react-router
  themeConfig.components = {
    ...themeConfig.components,
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
  }

  const theme = createTheme({
    ...themeConfig,
    cssVariables: {
      colorSchemeSelector: 'data', // We don't use 'class' because it interferes with xyflow dark/light classes
      cssVarPrefix: 'mui',
    },
  })

  return theme
}
